import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import Notifications from "@/pages/Notifications";

export const Route = createFileRoute("/_app/notifications")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="notifications">
      <Notifications />
    </ModuleGuard>
  );
}
